export default "<div>\n\t<ng-container [ngSwitch]=\"component\">\n\t\t</ng-container>\n</div>";